module Visonum.BulkPingApp.StaticConfig
  ( StaticConfig
  , getStaticConfig
  ) where

import Prelude

import Data.BasicURL (BasicURL)
import Data.BasicURL as BasicUrl
import Data.Bifunctor (lmap)
import Data.Either (Either, note)
import Data.Nullable (Nullable)
import Data.Nullable as Nullable
import Effect (Effect)
import Foreign.Object (Object)
import Foreign.Object as Obj

type StaticConfig =
  { speedMasterUrl :: BasicURL
  }

foreign import getEnvRaw :: Effect (Object (Nullable String))

getStaticConfig :: Effect (Either String StaticConfig)
getStaticConfig = do
  env <- getEnvRaw
  pure $ parseStaticConfig env

parseStaticConfig :: Object (Nullable String) -> Either String StaticConfig
parseStaticConfig obj = do
  speedMasterUrl <- getEnv obj (BasicUrl.parse >>> lmap show) "SPEED_MASTER_URL"

  pure { speedMasterUrl }

getEnv :: forall a. Object (Nullable String) -> (String -> Either String a) -> String -> Either String a
getEnv obj parse key = do
  nullableVal <- Obj.lookup key obj
    # note ("Missing env var: " <> key)

  val <- Nullable.toMaybe nullableVal
    # note ("Env var is null: " <> key)

  parse val
